module.exports = "<example-shell\n  exampleId=\"loading\" [title]=\"title\" [summary]=\"summary\" [dataSnippet]=\"dataSnippet\" [events]=\"events\" (clear)=\"clearEvents()\">\n  <stackline-data-table\n    title=\"Loading state\"\n    [columns]=\"orderColumns\"\n    [data]=\"orders\"\n    [progressPending]=\"true\">\n  </stackline-data-table>\n</example-shell>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/loading/loading.component.html
// module id = ./src/app/examples/loading/loading.component.html
// module chunks = main